import { emailThemesRoutes } from "./emailThemeRoutes";
import { integrationsRoutes } from "./integrationsRoutes";
import { ldapRoutes } from "./ldapRoutes";
export const pointRoutes = [
  ...emailThemesRoutes,
  ...integrationsRoutes,
  ...ldapRoutes,
];

